import React from 'react';
import CollectionFetch from "@web/ui/containers/CollectionFetch";
import DashboardFullRow from "./DashboardFullRow";
// import LineAppTasks from "./LineAppTasks";
import CallsList from "./CallsList";

function CallsContent() {
  return <DashboardFullRow>
    <section style={{width: "100%", margin: "0 auto"}}>
      <CollectionFetch collectionId="calls" component={CallsList} />
    </section>
  </DashboardFullRow>
}

export default CallsContent;
